import io from 'socket.io-client'

class PresenceSocketService {
    socket: any = null
    private listeners: { channel: string; callback: Function }[] = []

    connect(token: string) {
        if (this.socket?.connected) return
        this.disconnect()

        this.socket = io('', {
            path: '/socket.io',
            query: { token },
            transports: ['websocket', 'polling'],
        })

        for (const { channel, callback } of this.listeners) {
            this.socket.on(channel, callback)
        }
    }

    on(channel: string, callback: Function) {
        if (!this.socket) {
            this.listeners.push({ channel, callback })
            return
        }
        this.socket.on(channel, callback)
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect()
            this.socket = null
        }
    }
}

export default new PresenceSocketService()